import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import BusinessComponents from '@toy/business-components';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { useInstances } from '@/hooks/use-instances';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import $filters from '@/core/plugins/filter';

import i18n from '@/lang';

import sentry from '@/core/plugins/sentry';
import componentsInstall from '@/core/plugins/components-install';
import 'normalize.css';
import '@/styles/index.scss';
import 'virtual:uno.css';
import '@toy/business-components/dist/style.css';
import './core/plugins/permission';
import { getLanguageData } from './lang/utils';
import http from '@/core/http';
import { useProvide } from '@toy/v-use';

const { setVueInstance } = useInstances();
export const app = createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus, {
    size: 'default',
    locale: getLanguageData(),
  })
  .use(i18n)
  .use(BusinessComponents, undefined, http)
  .use($filters)

  .use(sentry);
setVueInstance(app);
componentsInstall(app);
app.mount('#app');
useProvide(app, { http });
